module.exports = __webpack_public_path__ + "img/gravity_logo_sm.23c83df9.png";